import PAYMENT_ORIGIN_ALL from 'constants/payment/paymentOriginAll.const';
import C from 'utils/values/constant.util';

const PAYMENT_ORIGIN_NAME = C({
  [PAYMENT_ORIGIN_ALL.slickPos]: 'cashUp.paymentOriginNames.clientBillsInStore',
  [PAYMENT_ORIGIN_ALL.slickPosRefund]: 'cashUp.paymentOriginNames.clientBillsRefundedInStore',
  [PAYMENT_ORIGIN_ALL.slickPosDeposit]: 'cashUp.paymentOriginNames.depositsTakenInStore',
  [PAYMENT_ORIGIN_ALL.slickPosDepositRefund]: 'cashUp.paymentOriginNames.depositsRefundedInStore',
  [PAYMENT_ORIGIN_ALL.slickPosVoucher]: 'cashUp.paymentOriginNames.vouchersSold',
  [PAYMENT_ORIGIN_ALL.slickPosVoucherRefund]: 'cashUp.paymentOriginNames.vouchersRefunded',
  [PAYMENT_ORIGIN_ALL.tipPos]: 'cashUp.paymentOriginNames.tips',
  [PAYMENT_ORIGIN_ALL.tipPosRefund]: 'cashUp.paymentOriginNames.tipsRefunded',
  [PAYMENT_ORIGIN_ALL.cardOnFile]: 'cashUp.paymentOriginNames.clientBillsOnline',
  [PAYMENT_ORIGIN_ALL.cardOnFileRefund]: 'cashUp.paymentOriginNames.clientBillsRefundedOnline',
  [PAYMENT_ORIGIN_ALL.ncobDeposit]: 'cashUp.paymentOriginNames.depositsTakenOnline',
  [PAYMENT_ORIGIN_ALL.ncobDepositRefund]: 'cashUp.paymentOriginNames.depositsRefundedOnline',
  [PAYMENT_ORIGIN_ALL.noShowFee]: 'cashUp.paymentOriginNames.noshowFees',
  [PAYMENT_ORIGIN_ALL.noShowFeeRefund]: 'cashUp.paymentOriginNames.noshowFeesRefunded',
  [PAYMENT_ORIGIN_ALL.onlineVoucher]: 'cashUp.paymentOriginNames.vouchersSold',
  [PAYMENT_ORIGIN_ALL.onlineVoucherRefund]: 'cashUp.paymentOriginNames.vouchersRefunded',
  [PAYMENT_ORIGIN_ALL.tipOnline]: 'cashUp.paymentOriginNames.tips',
  [PAYMENT_ORIGIN_ALL.tipOnlineRefund]: 'cashUp.paymentOriginNames.tipsRefunded',
  [PAYMENT_ORIGIN_ALL.tip]: 'cashUp.paymentOriginNames.tips',
  [PAYMENT_ORIGIN_ALL.tipRefund]: 'cashUp.paymentOriginNames.tipsRefunded',
  [PAYMENT_ORIGIN_ALL.amexFee]: 'cashUp.paymentOriginNames.amexFee',
  [PAYMENT_ORIGIN_ALL.disputeFee]: 'cashUp.paymentOriginNames.disputeFee',
  [PAYMENT_ORIGIN_ALL.refundFee]: 'cashUp.paymentOriginNames.refundFees',
});

// noinspection JSUnusedGlobalSymbols
export default PAYMENT_ORIGIN_NAME;
